// extracted by mini-css-extract-plugin
export var btn = "Q_mY s_sK s_sw d_bz d_bP d_bD d_dw";
export var full = "Q_xN d_w d_H";
export var hoverStyle = "Q_m1";
export var zoom = "Q_m2";